import{useSelector}from'react-redux';const useGoogleMapsKey=()=>{return useSelector(state=>state.googleMapsKey||'');};export default useGoogleMapsKey;